module.exports = __webpack_public_path__ + "img/logo_CN.f418ef49.png";